<div class="config-page">
  <h1>Configuration</h1>
  <p class="subtitle">Read-only overview of the environment configuration bundled into this build.</p>

  <section>
    <h2>Build</h2>
    <table>
      <tbody>
        <tr><th>App version</th><td>{{ appVersion }}</td></tr>
        <tr><th>Environment</th><td>{{ environment.envName }}</td></tr>
        <tr><th>Hostname</th><td>{{ hostname || "-" }}</td></tr>
      </tbody>
    </table>
  </section>

  <section>
    <h2>Detected at runtime</h2>
    <table>
      <tbody>
        <tr><th>Version</th><td>{{ detectedVersion }}</td></tr>
        <tr><th>Modern auth flow</th><td>{{ modernAuthFlow }}</td></tr>
        <tr><th>Dev mode</th><td>{{ devMode }}</td></tr>
        <tr><th>Active client ID</th><td>{{ activeApiKey }}</td></tr>
        <tr><th>Active Gigya API domain</th><td>{{ activeGigyaApiDomain }}</td></tr>
        <tr><th>Active fallback URL</th><td>{{ activeFallbackUrl || "-" }}</td></tr>
      </tbody>
    </table>
  </section>

  <section>
    <h2>Raw environment</h2>
    <table>
      <tbody>
        <tr><th>apiKey</th><td>{{ environment.apiKey }}</td></tr>
        <tr><th>nsgoApiKey</th><td>{{ environment.nsgoApiKey }}</td></tr>
        <tr><th>fallbackUrlB2B</th><td>{{ environment.fallbackUrlB2B }}</td></tr>
        <tr><th>fallbackUrlB2C</th><td>{{ environment.fallbackUrlB2C }}</td></tr>
        <tr><th>fallbackNsgo</th><td>{{ environment.fallbackNsgo }}</td></tr>
        <tr><th>gigyaApiDomainNsgo</th><td>{{ environment.gigyaApiDomainNsgo }}</td></tr>
        <tr>
          <th>gigyaApiDomainsByHostname</th>
          <td>
            @if (gigyaApiDomainsByHostname.length === 0) {
              <span>-</span>
            }
            @for (entry of gigyaApiDomainsByHostname; track entry[0]) {
              <div>{{ entry[0] }} &rarr; {{ entry[1] }}</div>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</div>
